import React from 'react'

import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/UnitInput.style'

import type { UnitInputProps } from './UnitInput.types'

const UnitInput: React.FC<UnitInputProps> = ({
  type,
  value,
  onChange,
  id,
  name,
  onKeyDown,
  onBlur,
  onClick,
  required,
  disabled,
  inputLength,
  autoComplete = true,
  describedBy,
  labels,
  dataSelectorPrefix,
}: UnitInputProps) => {
  const inputId = `${id}-${type}`
  const placeholders = {
    day: 'DD',
    month: 'MM',
    year: 'YYYY',
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    if (onClick) onClick()
    event.stopPropagation()
  }
  return (
    <Styled.UnitInputContainer showDelimeter={type !== 'year'} data-selector={getDataSelector(dataSelectorPrefix)}>
      <Styled.Label htmlFor={inputId} data-selector={getDataSelector(dataSelectorPrefix, 'label')}>
        {labels && labels[type]}
      </Styled.Label>
      <Styled.UnitInput
        unitType={type}
        id={inputId}
        name={inputId}
        type='text'
        maxLength={inputLength}
        size={inputLength}
        onChange={onChange}
        value={value}
        placeholder={placeholders[type]}
        onKeyDown={onKeyDown}
        onClick={handleClick}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        aria-disabled={disabled}
        aria-describedby={describedBy}
        autoComplete={autoComplete ? 'on' : 'off'}
        data-selector={getDataSelector(dataSelectorPrefix, 'input')}
      />
    </Styled.UnitInputContainer>
  )
}

export default UnitInput
